import { render, staticRenderFns } from "./approveListModal.vue?vue&type=template&id=9f70777c&"
import script from "./approveListModal.vue?vue&type=script&lang=js&"
export * from "./approveListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports